<template>
  <div class="vipProductList-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-button
        type="primary"
        size="small"
        @click="vipOperation('add', tableData)"
        class="add-input"
      >
        +新增
      </el-button>
      <el-button type="primary" size="small" @click="getOfficialList()"
        >搜索</el-button
      >
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      height="700"
      v-loading="loading"
      element-loading-text="拼命加载中"
      @sort-change="handleSortChange"
      element-loading-spinner="el-icon-loading"
    >
      <el-table-column
        prop="id"
        label="ID"
        align="center"
        width="250"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.id || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="officialName"
        label="名称"
        align="center"
        width="200"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.officialName }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="officialDesc"
        label="描述"
        align="center"
        width="200"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.officialDesc }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序" align="center" width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.sort }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="officialImg"
        label="图标"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <img-load
            :src="imgUrl + scope.row.officialImg"
            :width="'180px'"
            :height="'90px'"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="officialUrl"
        label="链接"
        align="center"
        width="500"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.officialUrl || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="officialType"
        label="类型"
        align="center"
        width="140"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.officialType == "1" ? "下载" : "社区" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="position" label="位置" align="center" width="140">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.position == 1">
            商务合作
          </el-tag>
          <el-tag type="success" v-else-if="scope.row.position == 2"
            >社群</el-tag
          >
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="isActive" label="状态" align="center" width="140">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.isActive"
            active-text="启用"
            inactive-text="禁用"
            disabled
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column
        prop="isHomepageAds"
        label="是否首页广告开关"
        align="center"
        width="140"
      >
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.isHomepageAds"
            active-text="启用"
            inactive-text="禁用"
            disabled
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="更新时间"
        align="center"
        width="160"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.updatedAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="160">
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            icon="el-icon-edit"
            @click="vipOperation('edit', scope.row)"
          ></el-button>
          <el-button
            type="danger"
            size="mini"
            icon="el-icon-delete"
            @click="removeAdmin(scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--新增、编辑弹框-->
    <official-action
      ref="addOfficial"
      @handlerOfficialList="handlerOfficialList"
    ></official-action>
  </div>
</template>
<script>
import API from "@/api";
import { sortEscape } from "@/utils/global";
import OfficialAction from "./components/officialAction";
import baseConfig from "@/utils/serverUrlConfig";
export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      imgUrl: baseConfig.imgUrl,
      tableData: [],
      // VIP商品列表请求参数
      param: {
        isActive: undefined,
        pageNumber: 1,
        pageSize: 30,
      },
    };
  },
  components: {
    OfficialAction,
  },
  created() {
    this.getOfficialList(this.param);
  },
  methods: {
    // 请求商品列表
    getOfficialList() {
      this.loading = true;
      API.getOfficialList(this.param)
        .then((res) => {
          if (res.code === 200 && res.data.length > 0) {
            this.tableData = res.data;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 数据排序
    handleSortChange(column) {
      this.param.value = sortEscape(column.order);
      this.param.key = column.prop;
      this.getOfficialList(this.param);
    },
    // 删除
    removeAdmin(row) {
      this.$confirm("您确定要删除吗？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        API.delOfficial({ id: [row.id] }).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getOfficialList();
          } else {
            this.$message.error("删除失败！");
          }
        });
      });
    },
    // 新增、编辑操作
    vipOperation(type, data) {
      this.$refs.addOfficial.open(type, data);
    },
    // 监听编辑、或者添加成功过后重新拉去数据
    handlerOfficialList() {
      this.getOfficialList();
    },
  },
};
</script>

<style lang="scss">
.add-input {
  margin-left: 0 !important;
}
</style>
